export default "__VITE_ASSET__B25a91t2__"